var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: "25",
    cy: "25",
    r: "25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.47 8.1a4.38 4.38 0 0 0-4.38 4.37v7.65a1.1 1.1 0 0 0 1.1 1.1 2.19 2.19 0 1 1 0 4.37c-.6 0-1.1.5-1.1 1.1v7.65a4.38 4.38 0 0 0 4.38 4.38H26.9a9.87 9.87 0 0 1-1.28-2.19H14.47c-1.21 0-2.19-.98-2.19-2.19v-6.7a4.38 4.38 0 0 0 0-8.47v-6.7c0-1.21.98-2.19 2.19-2.19h12c.6 0 1.16.24 1.58.68l4.4 4.6c.4.4.61.94.61 1.5V23a9.83 9.83 0 0 1 2.19-.13v-5.8c0-1.13-.44-2.21-1.22-3.03l-4.4-4.6a4.37 4.37 0 0 0-3.16-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.1 11.92c.61 0 1.1.5 1.1 1.1v4.37a1.1 1.1 0 1 1-2.18 0v-4.37c0-.6.48-1.1 1.09-1.1zM20.98 11.92c.6 0 1.1.5 1.1 1.1v4.37a1.1 1.1 0 1 1-2.19 0v-4.37c0-.6.49-1.1 1.1-1.1zM25.95 13.02a1.1 1.1 0 1 0-2.18 0v4.37a1.1 1.1 0 1 0 2.18 0zM29.23 15.2c.6 0 1.1.5 1.1 1.1v1.1a1.1 1.1 0 1 1-2.19 0v-1.1c0-.6.49-1.1 1.1-1.1zM31.42 31.6a1.1 1.1 0 1 0 0 2.2h6.56a1.1 1.1 0 1 0 0-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.7 24.5a8.2 8.2 0 1 1 0 16.4 8.2 8.2 0 0 1 0-16.4zm6.02 8.2a6.02 6.02 0 1 0-12.03 0 6.02 6.02 0 0 0 12.03 0z",
    fillRule: "evenodd"
  })));
});